// extracted by mini-css-extract-plugin
export default {"title":"ServiceProviderForm_title__eGfyZ","text":"ServiceProviderForm_text__iIKW-","labe":"ServiceProviderForm_labe__LPZvG"};